export default {
  label: '高级人力资源专员',
  id: '0',
  children: [
    {
      label: '岗位定义',
      id: '0-1',
      children: [
        {
          label: '高级人力资源专员是人力资源专员的高级职位，负责更复杂的人力资源管理工作，包括薪酬管理、员工关系维护等',
          id: '0-1-1',
        },
      ],
    },
    {
      label: '岗位职责',
      id: '0-2',
      children: [
        {
          label: '定期进行人力资源现状分析和配置，实施人才盘点',
          id: '0-2-1',
        },
        {
          label: '负责薪酬福利结构的设计与核算',
          id: '0-2-2',
        },
        {
          label: '开发并维护招聘渠道，优化招聘流程',
          id: '0-2-3',
        },
        {
          label: '负责员工关系管理，处理劳动争议',
          id: '0-2-4',
        },
        {
          label: '参与企业文化建设，传播公司价值观',
          id: '0-2-5',
        }
      ],
    },
    {
      label: '技能要求',
      id: '0-3',
      children: [
        {
          label: '全日制本科及以上学历，人力资源管理或相关专业优先',
          id: '0-3-1',
        },
        {
          label: '至少2年相关工作经验，有招聘或员工关系模块经验者优先',
          id: '0-3-2',
        },
        {
          label: '熟悉劳动法及相关政策',
          id: '0-3-3',
        },
        {
          label: '具备较强的沟通能力和抗压能力',
          id: '0-3-4',
        }
      ],
    },
    {
      label: '薪资情况',
      id: '0-4',
      children: [
        {
          label: '年薪:18-30万',
          id: '0-4-1',
        },
      ],
    }
  ],
};